import { Badge } from '@playbooks/ui/components/badge';
import { Icon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';

import { IndexComposer } from './index-composer';

const IndexHero = ({ workspace, router, store, types = [] }) => {
	// Components
	const DecoratedChangelogLink = () => (
		<Link
			variant='outline'
			href='/blog/changelog/w8-partials'
			className='mb-7 h-7 gap-1.5 rounded-full border-border/70 bg-surface-raised/60 px-2.5 font-normal shadow-none backdrop-blur-sm hover:bg-surface-hover/80'>
			<Badge className='tracking-widest' variant='active'>
				NEW
			</Badge>
			<span className='block font-normal text-foreground-body md:hidden'>Submit Partials</span>
			<span className='hidden font-normal text-foreground-body md:block'>
				Partials: Submit components, blocks and more
			</span>
			<Icon
				className='size-[0.8rem] text-foreground-body'
				data-icon='inline-end'
				type='far'
				icon='chevron-right'
				aria-hidden
			/>
		</Link>
	);
	const DecoratedHeroTitle = () => (
		<h1 className='mx-auto max-w-lg text-4xl leading-[1.02] font-semibold tracking-[-0.04em] md:text-6xl'>
			Transform Ideas into Products.
		</h1>
	);
	const DecoratedHeroSubtitle = () => (
		<p className='mx-auto mt-5 max-w-md text-xl leading-7 font-normal tracking-[-0.01em] text-foreground-body'>
			Describe what you want to build. Playbooks turns it into working software you can run, deploy, and sell — starting
			now.
		</p>
	);

	// Render
	return (
		<section className='hero-grid hero-grid-index relative flex-1 flex-start-top min-h-[80svh] w-full bg-canvas pt-24 pb-28 md:pt-[18svh]'>
			<div className='relative z-1 w-full'>
				<div className='mx-auto w-full max-w-lg px-4 text-center'>
					<div className='relative mx-auto w-full'>
						<DecoratedChangelogLink />
						<DecoratedHeroTitle />
						<DecoratedHeroSubtitle />
						<IndexComposer workspace={workspace} router={router} store={store} types={types} />
					</div>
				</div>
			</div>
		</section>
	);
};
export { IndexHero };
